import React from 'react'
import { Text } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { formatDateMonthNameDayYear } from '../../utils/formatters'
import FirstLookIcon from './first-look-icon.svg'
import styles from './index.scss'

const cx = classnames.bind(styles)

export const firstLookHeaderContent = () => (
  <>
    <div data-elm-id='first_look_cta_header_content'>
      <Text
        color='green'
        size='large'
        weight='heavy'
        className={cx('first-look-icon-label')}
      >
        <img src={FirstLookIcon} />
      </Text>
    </div>
    <div data-elm-id='first_look_cta_body_content'>
      <Text size='huge' weight='heavy' className={cx('u-mb-2 u-mt-2')}>
        First Look Program
      </Text>
      <Text>
        First Look properties are sold exclusively to buyers who intend to live
        in the property or Approved Entities. Learn More:{' '}
        <a
          target='_BLANK'
          data-elm-id='first_look_cta'
          href='/firstlook'
          rel='noreferrer'
        >
          View First Look FAQ’s.
        </a>
      </Text>
    </div>
  </>
)

export const firstLookEndContent = listing => {
  const { first_look_end_date: firstLookProgramEndDate } =
    listing.listing_configuration

  return {
    label: (
      <Text color='gray' data-elm-id='first_look_end_date_label'>
        First Look Period Ends
      </Text>
    ),
    value: (
      <Text color='gray' weight='heavy' data-elm-id='first_look_end_date_value'>
        {formatDateMonthNameDayYear(firstLookProgramEndDate)}
      </Text>
    ),
  }
}
